import { Component } from '@angular/core';
import { MainBtnComponent } from '../main-btn/main-btn.component';

@Component({
  selector: 'app-cover-static-paper',
  imports: [
    // MainBtnComponent
  ],
  templateUrl: './cover-static-paper.component.html',
  styleUrl: './cover-static-paper.component.css'
})
export class CoverStaticPaperComponent {

}
